import { FC, useCallback, useEffect, useState } from 'react';
import { Button } from 'components/shared/Button';
import styles from './AdminView.module.scss';
import { adminReportURL } from 'utils/paths';
import instance from 'api/axiosConfig';
import { downloadFile } from 'utils/download';
import { AdminPanel } from 'utils/strings';
import { useAppDispatch, useAppSelector } from 'redux/store';
import {
  selectLoginData,
  selectChangePasswordStatus,
} from 'redux/admin/selectors';
import { resetLoginData, changePasswordSucceeded } from 'redux/admin';

interface AdminViewProps {
  routeTo: () => void;
  onResetPassword: (isReset: boolean) => void;
}

const AdminView: FC<AdminViewProps> = ({ routeTo, onResetPassword }) => {
  const loginData = useAppSelector(selectLoginData);
  const isResetSucceeded = useAppSelector(selectChangePasswordStatus);
  const dispatch = useAppDispatch();
  const [isHidden, setIsHidden] = useState(false);

  const handleLogOut = () => dispatch(resetLoginData());
  const handleResetPassword = useCallback(() => {
    onResetPassword(true);
  }, [onResetPassword]);

  useEffect(() => {
    if (!loginData) {
      routeTo();
    }

    if (isResetSucceeded) {
      setIsHidden(true);
      const timeout = setTimeout(() => {
        setIsHidden(false);
      }, 5000);

      dispatch(changePasswordSucceeded());
      return () => clearTimeout(timeout);
    }
  }, [loginData]);

  const download = async () => {
    try {
      const response = await instance.get(adminReportURL, {
        headers: {
          Authorization: `Bearer `.concat(loginData?.access_token ?? ''),
        },
      });
      if (response.status === 200) {
        downloadFile(response, AdminPanel.reportName);
      }
    } catch {
      handleLogOut();
    }
  };

  return (
    <section className={styles.login_view}>
      <h1>{AdminPanel.AdminView.h1}</h1>
      {isHidden && (
        <p style={{ transition: 'opacity 0.3s' }}>
          {AdminPanel.AdminView.passwordChanged}
        </p>
      )}
      <Button
        className={`${styles.button_styles} ${styles.button_send}`}
        onClick={() => void download()}
      >
        {AdminPanel.AdminView.downloadReport}
      </Button>
      <Button className={styles.button_styles} onClick={handleResetPassword}>
        {AdminPanel.AdminView.changePassword}
      </Button>
      <Button
        className={`${styles.button_styles} ${styles.button_logout}`}
        onClick={() => handleLogOut()}
      >
        {AdminPanel.AdminView.logOut}
      </Button>
    </section>
  );
};
export default AdminView;
